<template>
<div class="app-body">
  <layout-header></layout-header>
  <main class="secure-content">
    <router-view></router-view>
  </main>
</div>
</template>

<script>
export default {
  name: 'HomeLayout',
  components: {}
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/layout/Layout.vue